import { motion } from "framer-motion";
import { ReactNode, useEffect, useState } from "react";

export default function BalanceSlide({ children }: { children: ReactNode }) {
  const [isActive, setIsActive] = useState(true);

  const handleToggle = () => {
    setIsActive((prev) => !prev);
  };

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (!isActive) {
      timer = setTimeout(() => {
        setIsActive(true);
      }, 5000);
    }
    return () => clearTimeout(timer);
  }, [isActive]);

  return (
    <div
      className="cursor-pointer  w-40 h-9 relative flex items-center bg-gray-50 rounded-full border border-slate-100 shadow-sm p-1"
      onClick={handleToggle}
    >
      {/* Moving Circle */}
      <motion.div
        className="w-6 h-6 bg-gradient-to-l from-indigo-800 via-cyan-600 to-emerald-400 rounded-full shadow-md z-10 relative"
        initial={{ x: isActive ? 2 : 125 }}
        animate={{ x: isActive ? 2 : 125 }}
        transition={{ duration: 0.4, ease: "easeInOut" }}
      />
      {/* Text Content */}
      <motion.div
        className={`flex-1 text-center text-sm font-semibold text-indigo-800 transition-opacity duration-300`}
        initial={{ x: isActive ? 0 : -30 }}
        animate={{ x: isActive ? 0 : -30 }}
        transition={{ duration: 0.4, ease: "easeInOut" }}
      >
        {isActive ? "Balance" : children}
      </motion.div>
    </div>
  );
}
